import { Text } from '@mantine/core';
import { ReactNode } from 'react';
import { UnderlineTooltip } from 'src/UI/common';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { formatCurrency, Frequency } from '../utils';

export function frequencyAmountCell(
  frequency: Frequency,
  monthly: number,
  annually: number,
  options?: { positive?: boolean },
): ReactNode {
  const displayed = frequency === 'monthly' ? monthly : annually;
  const label =
    frequency === 'monthly'
      ? `Annually: ${formatCurrency(annually)}`
      : `Monthly: ${formatCurrency(monthly)}`;
  const prefix = options?.positive ? '+' : '';

  return (
    <UnderlineTooltip label={label}>
      {prefix}
      {formatCurrency(displayed)}
    </UnderlineTooltip>
  );
}

export function SectionTotal({
  children,
  tooltipLabel,
}: {
  children: ReactNode;
  tooltipLabel?: string;
}) {
  if (!tooltipLabel) {
    return (
      <Text size="lg" fw={FONT_WEIGHTS.bold} c="gray.10" style={{ whiteSpace: 'nowrap' }}>
        {children}
      </Text>
    );
  }

  return (
    <UnderlineTooltip label={tooltipLabel} size="lg" fw={FONT_WEIGHTS.bold}>
      {children}
    </UnderlineTooltip>
  );
}
